import { useApiLoading } from "./apiLoader";
import "./globalLoadingOverlay.css";

export function GlobalLoadingOverlay() {
  const { isLoading } = useApiLoading();

  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
        <div className="global-loading-overlay">
        <div className="global-loading-spinner" />
        </div>
    </div>
  );
}